/* import __COLOCATED_TEMPLATE__ from './section.hbs'; */
import { classNameBindings, classNames, tagName } from '@ember-decorators/component';
import Component from '@ember/component';
import styles from './section.module.scss';

@classNames('pw-section', styles.component)
@classNameBindings('hide:hidden', 'isEditMode:edit-mode', 'sectionName')
@tagName('section')
export default class PracticeWebsiteSection extends Component {}
